import { HttpClient } from 'core/common/services';
import {
  CreateAskNebulaUserParams,
  UpdateUserPayload,
  User,
  UserAskNebula,
  UserProfile,
} from '../../entities';
import { UserAskNebulaDtoMapper, UserDtoMapper, UserProfileDtoMapper } from '../../mappers';
import { UserAskNebulaDto, UserDto, UserProfileDto } from '../dto';
import { UserServiceInterface } from './UserServiceInterface';

export class UserService implements UserServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async getUserInformation(): Promise<UserProfile> {
    const { data } = await this.httpClient.get<UserProfileDto>('/user-service/users/me/info');

    const dtoMapper = new UserProfileDtoMapper();

    return dtoMapper.toEntity(data);
  }

  async getNebulaAppLink(host: string): Promise<string> {
    const { data } = await this.httpClient.get<{ link: string }>('/deep-link/funnel', {
      params: {
        host,
      },
    });

    return data.link;
  }

  async createAskNebulaUser(payload: CreateAskNebulaUserParams): Promise<UserAskNebula> {
    const { data } = await this.httpClient.post<UserAskNebulaDto>('/user/funnel', {
      data: payload,
    });

    const dtoMapper = new UserAskNebulaDtoMapper();

    return dtoMapper.toEntity(data);
  }

  async update(payload: UpdateUserPayload): Promise<User> {
    const { data } = await this.httpClient.put<UserDto>(
      '/user-service/users/last-funnel-interaction',
      {
        data: payload,
      },
    );

    const dtoMapper = new UserDtoMapper();

    return dtoMapper.toEntity(data);
  }
}
